import { useMemo } from 'react';
import { useStore } from 'common/store';
import { TITLE_CONFIG } from '../constants/titles';
import { 
  extractDateFromUrl, 
  getPageNameFromRouteType,
  getPageTypeFromPathname, 
  getRouteType 
} from '../routeHelpers';

export const useResolvedTitleParts = (pathname: string, search: string) => {
  const [{ firmInfo, fundInfo, companyInfo }] = useStore();

  return useMemo(() => {
    const pageType = getPageTypeFromPathname(pathname);
    const routeType = getRouteType(pathname);
    const pageName = getPageNameFromRouteType(routeType);
    const measurementDate = extractDateFromUrl(search);

    let entityName = '';
    let isLoading = false;

    // Guarded resolution based on context
    switch (pageType) {
      case 'company':
        entityName = companyInfo?.name || '';
        isLoading = !companyInfo?.name;
        break;
      case 'fund':
        entityName = fundInfo?.name || '';
        isLoading = !fundInfo?.name;
        break;
      case 'firm':
        entityName = firmInfo?.name || '';
        isLoading = !firmInfo?.name;
        break;
      default:
        break;
    }

    // Build parts: If loading, we fall back to the default title to avoid weird separators
    const titleParts = isLoading 
      ? [TITLE_CONFIG.DEFAULT_TITLE] 
      : [entityName, pageName, measurementDate].filter(Boolean);

    const fullTitle = titleParts.length > 0 
      ? titleParts.join(TITLE_CONFIG.SEPARATOR) 
      : TITLE_CONFIG.DEFAULT_TITLE;

    return { 
      fullTitle, 
      entityName, 
      pageName, 
      measurementDate,
      isLoading 
    };
  }, [pathname, search, firmInfo, fundInfo, companyInfo]);
};
